'use client';

import { c as _c } from "react/compiler-runtime";
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';
import { useMemo, useCallback } from 'react';
import { debounce } from 'lodash';
import { DEFAULT_SORT_ORDER } from 'commons/constants';
const useSearchUrlQueryParams = () => {
  const $ = _c(13);
  const history = useHistory();
  const pathname = history?.location?.pathname ?? "";
  let t0;
  if ($[0] !== history?.location?.search) {
    t0 = queryString.parse(history?.location?.search ?? "");
    $[0] = history?.location?.search;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    q: t1,
    category: t2,
    sortBy: t3
  } = t0;
  const queryUrlParam = t1 === undefined ? "" : t1;
  const categoryUrlParam = t2 === undefined ? "products_jb4" : t2;
  const sortByUrlParam = t3 === undefined ? DEFAULT_SORT_ORDER : t3;
  let t4;
  if ($[2] !== history) {
    t4 = debounce(updates => {
      if (updates) {
        const initialUrlParams = queryString.parse(history?.location?.search ?? "");
        const updatedUrlParams = queryString.stringify({
          ...initialUrlParams,
          category: initialUrlParams?.category ?? "products_jb4",
          filter: initialUrlParams?.filter ?? "*",
          ...updates
        });
        history.replace?.(`${history.location.pathname}${!history.location.pathname.endsWith("/") ? "/" : ""}?${updatedUrlParams}`);
      }
    }, [1000]);
    $[2] = history;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const updateUrlParam = t4;
  let t5;
  if ($[4] !== history) {
    t5 = updates_0 => {
      if (updates_0) {
        const initialUrlParams_0 = queryString.parse(history?.location?.search ?? "");
        const updatedUrlParams_0 = queryString.stringify({
          ...initialUrlParams_0,
          category: initialUrlParams_0?.category ?? "products_jb4",
          filter: initialUrlParams_0?.filter ?? "*",
          ...updates_0
        });
        history.replace?.(`${history.location.pathname}${!history.location.pathname.endsWith("/") ? "/" : ""}?${updatedUrlParams_0}`);
      }
    };
    $[4] = history;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const updateUrlParamImmediate = t5;
  let t6;
  if ($[6] !== categoryUrlParam || $[7] !== pathname || $[8] !== queryUrlParam || $[9] !== sortByUrlParam || $[10] !== updateUrlParam || $[11] !== updateUrlParamImmediate) {
    t6 = {
      pathname,
      queryUrlParam,
      categoryUrlParam,
      sortByUrlParam,
      updateUrlParam,
      updateUrlParamImmediate
    };
    $[6] = categoryUrlParam;
    $[7] = pathname;
    $[8] = queryUrlParam;
    $[9] = sortByUrlParam;
    $[10] = updateUrlParam;
    $[11] = updateUrlParamImmediate;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default useSearchUrlQueryParams;